import { render, staticRenderFns } from "./MultipleChoiceQuestion.vue?vue&type=template&id=5525c2b4&scoped=true&"
import script from "./MultipleChoiceQuestion.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoiceQuestion.vue?vue&type=style&index=0&id=5525c2b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5525c2b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VCheckbox,VRadio,VRadioGroup})
